"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPageHeaderBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var page_header_constants_1 = require("./page-header-constants");
var page_header_constants_2 = require("./page-header-constants");
var page_header_constants_3 = require("./page-header-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcPageHeaderBehavior = (function (_super) {
    __extends(BcPageHeaderBehavior, _super);
    function BcPageHeaderBehavior() {
        return _super.call(this) || this;
    }
    BcPageHeaderBehavior.setUpAll = function () {
        var pageHeaderElements = Array.from(document.querySelectorAll("div[class~='".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, "']")));
        var elements = [];
        for (var _i = 0, pageHeaderElements_1 = pageHeaderElements; _i < pageHeaderElements_1.length; _i++) {
            var element = pageHeaderElements_1[_i];
            var bcPageHeaderBehavior = new BcPageHeaderBehavior();
            bcPageHeaderBehavior.setElement(element);
            bcPageHeaderBehavior.setUp();
            elements.push(bcPageHeaderBehavior);
        }
        return elements;
    };
    BcPageHeaderBehavior.prototype._setUp = function () {
        this.selectElements();
        this.addListeners();
    };
    BcPageHeaderBehavior.prototype.addListeners = function () {
        this.bcPageHeaderBackButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            window.history.back();
        });
    };
    BcPageHeaderBehavior.prototype.selectElements = function () {
        this.bcPageHeaderBackButton = this.mySelf.querySelector(".".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, " .").concat(page_header_constants_3.BC_PAGE_HEADER_BACK_BUTTON));
        this.bcPageHeaderBreadcrumb = this.mySelf.querySelector(".".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, " .").concat(page_header_constants_2.BC_PAGE_HEADER_BREADCRUMB_SELECTOR));
        this.bcPageHeaderBreadcrumbList = this.mySelf.querySelector(".".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, " .").concat(page_header_constants_2.BC_PAGE_HEADER_BREADCRUMB_SELECTOR, " ol"));
        this.bcPageHeaderBreadcrumbItems = Array.from(this.mySelf.querySelectorAll(".".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, " .").concat(page_header_constants_2.BC_PAGE_HEADER_BREADCRUMB_SELECTOR, " ol li")));
        this.bcPageHeaderButtonsRight = Array.from(this.mySelf.querySelectorAll(".".concat(page_header_constants_1.BC_PAGE_HEADER_SELECTOR, " .").concat(page_header_constants_1.BC_PAGE_HEADER_BUTTONS_RIGHT)));
        this.bcPageHeaderCountBreadcrumbItems = this.bcPageHeaderBreadcrumbItems.length;
    };
    return BcPageHeaderBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcPageHeaderBehavior = BcPageHeaderBehavior;
